// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n/** These styles aren't working in scoped css, so prefix with .frame */\n.frame .ag-cell a:hover {\n  text-decoration: underline;\n}\n", ""]);
// Exports
module.exports = exports;
